<template>
    <div class="modal-cookies" v-if="dialogVisible">
        <h3 class="col-10 c-ndarkfour m-auto">
            Utilizamos cookies para oferecer melhor experiência, melhorar o desempenho, analisar como você
            interage em nosso site e personalizar conteúdo. <br /> 
            Ao utilizar este site, você concorda com o uso de cookies. <router-link to="/politica"
                :class="`${getPrimaryColor}`">Saiba mais ></router-link>
        </h3>
        <div class="m-auto pr-4">
            <Button size="small" type="outline" :color="getPrimaryColor" class="button-outline" @click="clickedOk">
                Ok, entendi!
            </Button>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: true
        },
    },
    created() {
        this.dialogVisible = !(Cookies.get('agreedCookies') == 1)
    },
    methods: {
        clickedOk() {
            Cookies.set('agreedCookies', 1, {
                expires: 365 * 5,
                domain: process.env.VUE_APP_ROOT_DOMAIN
            })

            this.dialogVisible = false
        }
    },
}
</script>

<style lang="scss">
.modal-cookies {
    align-items: flex-start;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #DFE2EB;
    bottom: 1rem !important;
    box-shadow: 0px -2px 12px rgba(77, 85, 102, 0.1);
    display: flex;
    isolation: isolate;
    margin: 0 4rem;
    max-height: 104px;
    position: absolute;
    padding: 20px;
    width: 100%;

    h3 {
        color: #4D5566 !important;
        font-size: 14px;
        padding: 0 20px;
        margin: 0;
        line-height: 21px !important;
    }

    .button-outline {
        min-width: 147px;
        min-height: 40px;
        font-size: 14px;
    }
}

@media screen and (min-width: 0){
    .modal-cookies{
        max-width: calc(100% - 120px); 
    }
}

@media screen and (min-width: 1280px){
    .modal-cookies{
        max-width: calc(100% - 120px);
    }
}

@media screen and (min-width: 1560px){
    .modal-cookies{
        max-width: calc(100% - 140px);
    }
}
</style>